import { render, staticRenderFns } from "./FormStepWrapper.vue?vue&type=template&id=c31b6316&scoped=true&"
import script from "./FormStepWrapper.vue?vue&type=script&lang=js&"
export * from "./FormStepWrapper.vue?vue&type=script&lang=js&"
import style0 from "./FormStepWrapper.vue?vue&type=style&index=0&id=c31b6316&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31b6316",
  null
  
)

export default component.exports